/* N36 Friends and Family Sale (DRAFT PREVIEW, built 2026-10-10, review fixes same day).
 *
 * What it does: when a shopper's cart carries the code N36FRIENDS, every sale
 * item shows its list price struck through and its sale price wherever it
 * appears (collection cards, quick add, product page, pair cards), a bar runs
 * across the top, and on the homepage the Friends and Family carousel takes
 * the place of the Game Day Favorites carousel. Everyone else sees normal
 * prices. The code itself does the charging at cart and checkout. This file
 * only changes what is DISPLAYED.
 *
 * Never touched: Build Your Box, Latitude, the box teaser price on product
 * pages, the cart itself (the cart shows the real discount from the code).
 *
 * Preview (draft/unpublished themes ONLY): add ?n36ff=preview to any URL to
 * see the display without the code. ?n36ff=off turns the preview off.
 *
 * Prices: Kirstin's final 12 sizes (Oct 13), including Ground Beef 1 lb $8.50.
 * Ground Beef 2 lb is excluded and remains $20.
 * Variant id: [list cents, sale cents].
 */
(function () {
  'use strict';

  var FF = {
    code: 'N36FRIENDS',
    starts: '2026-10-14', // inclusive, Central time
    ends: '2026-10-21',   // inclusive, Central time
    bar: 'Friends and Family Sale is on through Wed 10/21',
    /* Kirstin's final list (Oct 13): 12 sizes. Same numbers as
       n36f-checkout-delivery-date/farm-picks/config/friends-and-family.json.
       Variant id: [list cents, sale cents]. */
    v: {
      49703626211575: [5200, 3900], // Bone-In Short Rib 3 lb (25%)
      49608144224503: [4500, 3400], // Inside Skirt 16-24 oz (24%)
      49608144158967: [1100, 850],  // Ground Beef 1 lb $8.50 (Asher 10/11)
      49635675242743: [1800, 1400], // Fajita Steak 1 lb (22%)
      49608142487799: [1500, 1200], // Marrow Bones 1 lb (20%)
      50993243062519: [3800, 3200], // Bone-In NY Strip 18-20 oz / 1 (16%)
      49608142586103: [3400, 2900], // Bavette 12 oz (15%)
      49608143831287: [1400, 1200], // Stew Meat 1 lb (14%)
      51207411466487: [1900, 1700], // Denver 8-10 oz / 1 (11%)
      51273013919991: [1400, 1200], // Black Cod portion (14%)
      51051861770487: [2400, 2100], // Halibut portion (13%)
      51272603926775: [2800, 2500]  // White King Salmon portion (11%)
    },
    /* Product id -> { list cents: sale cents } for prices shown WITHOUT a
       variant id (card "from" prices, pair cards). Only prices that belong to
       exactly one size of the product, checked against every size Oct 12. */
    p: {
      9647226355959: { 5200: 3900 },  // Bone-In Short Rib (1 lb $19 excluded; 3 lb $52; 4 lb $69)
      9647226257655: { 4500: 3400 },  // Inside Skirt (8-16 $28; 16-24 $45)
      9647226192119: { 1100: 850 },   // Ground Beef (1 lb $11; 2 lb $20 not on sale)
      9654553346295: { 1800: 1400 },  // Fajita
      9647225241847: { 1500: 1200 },  // Marrow Bones
      9647226388727: { 3800: 3200 },  // Bone-In NY Strip (18-20 $38 only; 20-24 $44 not on sale)
      9647225307383: { 3400: 2900 },  // Bavette (8 oz $23; 12 oz $34; 16 oz $45)
      9647225995511: { 1400: 1200 },  // Stew Meat
      9647225635063: { 1900: 1700 },  // Denver (8-10 /1 $19 only)
      10123877581047: { 1400: 1200 }, // Black Cod portion
      10059954585847: { 2400: 2100 }, // Halibut portion
      10123854282999: { 2800: 2500 }  // White King Salmon portion
    }
  };

  var LS_SEEN = 'n36ff_seen', LS_OFF = 'n36ff_off', LS_CART = 'n36ff_cart', SS_PREVIEW = 'n36ff_preview';
  var VH = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';
  var originals = new WeakMap();
  var carouselUndo = [];
  var navOriginals = new WeakMap(), navUndo = [];
  var NAV_NEW = '.header__inline-menu a.header__menu-item[href$="/collections/whats-new"], .menu-drawer a[href$="/collections/whats-new"]';
  var active = false;

  function store(kind) {
    try { return kind === 'session' ? window.sessionStorage : window.localStorage; } catch (e) { return null; }
  }
  function sget(kind, k) { var s = store(kind); try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function sset(kind, k, v) { var s = store(kind); try { if (s) s.setItem(k, v); } catch (e) {} }
  function sdel(kind, k) { var s = store(kind); try { if (s) s.removeItem(k); } catch (e) {} }

  function todayCT() {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    } catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  // The draft theme ignores the start date so the code can be tested before Oct 14.
  // The live theme always waits for FF.starts.
  function inWindow() { var t = todayCT(); return (isDraftTheme() || t >= FF.starts) && t <= FF.ends; }
  function isDraftTheme() {
    var t = window.Shopify && window.Shopify.theme;
    return !!(t && t.role && t.role !== 'main');
  }
  function money(cents) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  function strikeHTML(list, sale, cls) {
    return '<s class="' + (cls || 'n36-card-was n36-otp-was') + '" data-n36ff-made="1"><span class="n36-vh-txt" style="' + VH + '">Regularly </span>' + money(list) + '</s> ' + money(sale);
  }
  function remember(el) { if (!originals.has(el)) originals.set(el, el.innerHTML); }

  /* ---------- preview switch (draft themes only) ---------- */
  function previewState() {
    if (!isDraftTheme()) { sdel('session', SS_PREVIEW); return false; }
    var q = new URLSearchParams(window.location.search).get('n36ff');
    if (q === 'preview') sset('session', SS_PREVIEW, '1');
    if (q === 'off') sdel('session', SS_PREVIEW);
    return sget('session', SS_PREVIEW) === '1';
  }

  /* ---------- the bar across the top ---------- */
  function showBar() {
    if (document.getElementById('n36ff-bar')) return;
    var bar = document.createElement('div');
    bar.id = 'n36ff-bar';
    bar.setAttribute('role', 'status');
    bar.style.cssText = 'background:#7A332B;color:#F6F2EA;text-align:center;font-size:14px;line-height:1.35;letter-spacing:.02em;padding:10px 16px;position:relative;z-index:5;';
    bar.textContent = FF.bar;
    document.body.insertBefore(bar, document.body.firstChild);
  }
  function hideBar() { var b = document.getElementById('n36ff-bar'); if (b) b.remove(); }

  /* ---------- prices marked by the snippets ---------- */
  function lookup(el) {
    var vid = el.getAttribute('data-n36ff-v');
    if (vid) return FF.v[vid] || null; // a known size: on sale or not, no guessing
    var pid = el.getAttribute('data-n36ff-p'), c = parseInt(el.getAttribute('data-n36ff-c'), 10);
    var m = pid && FF.p[pid];
    if (m && m[c]) return [c, m[c]];
    return null;
  }

  function syncOpenDialogs() {
    // Make every quick-add dialog's Add button match its checked size.
    document.querySelectorAll('dialog.n36-qa').forEach(function (d) {
      var sel = d.querySelector('[data-n36-qa-sel]:checked') || d.querySelector('[data-n36-qa-sel]');
      var btn = d.querySelector('[data-n36-qa-price]');
      var raw = sel && sel.getAttribute('data-price');
      if (raw && btn) btn.textContent = '— ' + raw;
    });
  }

  function paintMarked(root) {
    var scope = root || document;
    // n36-otp-sale-price spans (collection cards, quick add sizes, pair cards)
    scope.querySelectorAll('span[data-n36ff-c]').forEach(function (el) {
      if (originals.has(el)) return;
      var hit = lookup(el);
      if (!hit || el.querySelector('.n36-otp-was:not([data-n36ff-made])')) return;
      remember(el);
      el.innerHTML = strikeHTML(hit[0], hit[1]);
    });
    // Dawn price blocks (price.liquid)
    scope.querySelectorAll('.price[data-n36ff-c]').forEach(function (el) {
      var hit = lookup(el);
      if (!hit) return;
      var item = el.querySelector('.price__regular .price-item--regular');
      if (!item || originals.has(item)) return;
      remember(item);
      var from = /^\s*from\b/i.test(item.textContent);
      item.innerHTML = (from ? 'From ' : '') + strikeHTML(hit[0], hit[1]);
    });
    // quick-add size radios: the dialog's Add button reads data-price
    scope.querySelectorAll('input[data-n36-qa-sel][value]').forEach(function (inp) {
      var e = FF.v[inp.value];
      if (!e || inp.hasAttribute('data-n36ff-was-price')) return;
      inp.setAttribute('data-n36ff-was-price', inp.getAttribute('data-price') || '');
      inp.setAttribute('data-price', money(e[1]));
    });
    syncOpenDialogs();
    paintTags(scope);
  }

  /* ---------- "Sale" tags on every surface (Asher 2026-10-14) ----------
     Mirrors the site's New badge (.n36-card-new / .n36-pdp-new, oxblood) and
     stacks under it when a product carries both. Cards (collection grids,
     carousels, pair cards), Dawn cards, quick-add size rows, the product page
     hero and its size list. Every tag carries data-n36ff-made so unpaint
     removes them all. */
  function productOnSale(pid) { return !!(pid && FF.p[String(pid)]); }
  function makeTag(cls) {
    var t = document.createElement('span');
    t.className = 'n36ff-tag ' + cls;
    t.setAttribute('data-n36ff-made', '1');
    t.textContent = 'Sale';
    return t;
  }
  function tagHost(host, cls, belowSel) {
    if (!host || host.querySelector(':scope > .n36ff-tag')) return;
    var t = makeTag(cls);
    if (belowSel && host.querySelector(belowSel)) t.className += ' n36ff-tag--below';
    host.appendChild(t);
  }
  function paintTags(root) {
    var scope = root || document;
    // custom product cards: the price mark names the product (data-n36ff-p)
    scope.querySelectorAll('article.n36-card').forEach(function (card) {
      var mark = card.querySelector('[data-n36ff-p]');
      var onSale = (mark && productOnSale(mark.getAttribute('data-n36ff-p'))) ||
        Array.prototype.some.call(card.querySelectorAll('input[data-n36-qa-sel][value]'), function (i) { return !!FF.v[i.value]; });
      if (!onSale) return;
      tagHost(card.querySelector('.n36-card-media'), 'n36ff-tag--card', '.n36-card-new');
    });
    // Dawn cards (price.liquid blocks): tag the card media when present
    scope.querySelectorAll('.price[data-n36ff-c]').forEach(function (el) {
      if (!productOnSale(el.getAttribute('data-n36ff-p'))) return;
      var wrap = el.closest('.card-wrapper');
      tagHost(wrap && wrap.querySelector('.card__inner'), 'n36ff-tag--card', '.badge');
    });
    // quick-add size rows: inline tag beside the size name of each sale size
    scope.querySelectorAll('input[data-n36-qa-sel][value]').forEach(function (inp) {
      if (!FF.v[inp.value]) return;
      var label = inp.closest('label'), nm = label && label.querySelector('.nm');
      if (!nm || nm.querySelector('.n36ff-tag')) return;
      nm.appendChild(makeTag('n36ff-tag--inline'));
    });
  }
  function paintPdpTags() {
    if (!pdp) return;
    var opts = document.querySelectorAll('.n36-thickness .n36-thick-opt[data-variant-id]');
    var any = !!FF.v[pdp.variant && pdp.variant.value];
    opts.forEach(function (b) {
      if (!FF.v[b.getAttribute('data-variant-id')]) return;
      any = true;
      if (!b.querySelector('.n36ff-tag')) b.appendChild(makeTag('n36ff-tag--inline'));
    });
    if (any) tagHost(document.querySelector('.n36-gallery .n36-hero'), 'n36ff-tag--pdp', '.n36-pdp-new');
  }
  function unpaintTags() {
    document.querySelectorAll('.n36ff-tag[data-n36ff-made]').forEach(function (t) { if (t.parentNode) t.parentNode.removeChild(t); });
  }

  /* Friends and Family cards feature the available size in the same sale map
     that paints prices. A new cheaper, full-price variant must not displace
     that size. The real quick-add radios contain only available variants;
     missing or ambiguous sale choices are left unchanged. */
  function paintCarousel() {
    var onSalePage = /^\/collections\/friends-and-family\/?$/.test(window.location.pathname);
    document.querySelectorAll(onSalePage ? 'article.n36-card' : '[data-n36ff-reveal] article.n36-card').forEach(function (card) {
      var cp = card.querySelector('.n36-card-price');
      var mark = cp && cp.querySelector('span[data-n36ff-p]');
      if (!mark || originals.has(cp)) return;
      var productPrices = FF.p[mark.getAttribute('data-n36ff-p')];
      if (!productPrices) return;
      var dlg = card.querySelector('dialog.n36-qa');
      if (!dlg) return; // single-variant forms already submit their only size
      var eligible = Array.prototype.filter.call(dlg.querySelectorAll('input[data-n36-qa-sel][value]'), function (input) {
        var price = FF.v[input.value];
        return !input.disabled && price && productPrices[price[0]] === price[1];
      });
      if (eligible.length !== 1) return;
      var inp = eligible[0], e = FF.v[inp.value];
      var label = inp.closest('label'), name = label && label.querySelector('.nm');
      remember(cp);
      cp.innerHTML = strikeHTML(e[0], e[1]);
      if (name && name.textContent.trim()) {
        var size = document.createElement('span');
        size.style.cssText = 'font-size:.72em;font-weight:400;color:#6E6656;margin-left:2px;';
        size.textContent = name.textContent.trim();
        cp.appendChild(document.createTextNode(' '));
        cp.appendChild(size);
      }
      var prev = dlg.querySelector('input[data-n36-qa-sel]:checked');
      if (prev !== inp) {
        inp.checked = true;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
        carouselUndo.push(function () { if (prev) { prev.checked = true; prev.dispatchEvent(new Event('change', { bubbles: true })); } });
      }
      card.querySelectorAll('a.n36-card-link').forEach(function (a) {
        var old = a.getAttribute('href');
        if (!old) return;
        var hashAt = old.indexOf('#'), hash = hashAt < 0 ? '' : old.slice(hashAt);
        var base = hashAt < 0 ? old : old.slice(0, hashAt), queryAt = base.indexOf('?');
        var query = new URLSearchParams(queryAt < 0 ? '' : base.slice(queryAt + 1));
        query.set('variant', inp.value);
        a.setAttribute('href', (queryAt < 0 ? base : base.slice(0, queryAt)) + '?' + query.toString() + hash);
        carouselUndo.push(function () { a.setAttribute('href', old); });
      });
    });
    syncOpenDialogs();
  }

  function showSections(on) {
    var reveal = document.querySelectorAll('[data-n36ff-reveal]');
    reveal.forEach(function (el) { el.hidden = !on; el.style.display = on ? '' : 'none'; });
    // Only step Game Day aside when a Friends and Family carousel actually rendered.
    var swap = on && reveal.length > 0;
    document.querySelectorAll('[data-n36ff-hide]').forEach(function (el) { el.hidden = swap; el.style.display = swap ? 'none' : ''; });
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  function unpaintAll() {
    unpaintTags();
    while (carouselUndo.length) { try { carouselUndo.pop()(); } catch (e) {} }
    document.querySelectorAll('.n36-card-price, span[data-n36ff-c], .price[data-n36ff-c] .price__regular .price-item--regular').forEach(function (el) {
      if (originals.has(el)) { el.innerHTML = originals.get(el); originals.delete(el); }
    });
    document.querySelectorAll('input[data-n36ff-was-price]').forEach(function (inp) {
      inp.setAttribute('data-price', inp.getAttribute('data-n36ff-was-price'));
      inp.removeAttribute('data-n36ff-was-price');
    });
    document.querySelectorAll('[data-n36ff-qp]').forEach(function (qp) {
      qp.innerHTML = qp.getAttribute('data-n36ff-qp'); qp.removeAttribute('data-n36ff-qp');
    });
    syncOpenDialogs();
    pdpRefresh(false);
  }

  /* ---------- beef product page ---------- */
  var pdp = null, pdpMo = null;
  function findPdp() {
    var price = document.querySelector('.n36-pricerow .n36-price[id^="n36-price-"]');
    if (!price) return null;
    var sid = price.id.replace(/^n36-price-/, '');
    var g = function (n) { return document.getElementById(n + '-' + sid); };
    return { sid: sid, price: price, addPrice: g('n36-addprice'), mobar: g('n36-mobar-add'), variant: g('n36-variant-id'), qty: g('n36-quantity'), row: price.parentNode };
  }
  function pdpRefresh(on) {
    if (!pdp) return;
    var vid = pdp.variant && pdp.variant.value;
    var e = on ? FF.v[vid] : null;
    var qty = Math.max(1, parseInt(pdp.qty && pdp.qty.value, 10) || 1);
    var was = document.getElementById('n36-price-was-' + pdp.sid);
    if (e) {
      if (!was) {
        was = document.createElement('s');
        was.id = 'n36-price-was-' + pdp.sid;
        was.className = 'n36-price-was';
        was.setAttribute('data-n36ff-made', '1');
        was.style.cssText = 'color:#6E6656;font-weight:400;margin-right:.45rem;';
        pdp.row.insertBefore(was, pdp.price);
      }
      was.textContent = money(e[0]);
      was.hidden = false;
      pdp.price.textContent = money(e[1]);
      if (pdp.addPrice && pdp.addPrice.textContent) pdp.addPrice.textContent = '— ' + money(e[1] * qty);
      if (pdp.mobar && /^Add to Basket/.test(pdp.mobar.textContent)) pdp.mobar.textContent = 'Add to Basket — ' + money(e[1] * qty);
    } else {
      if (was && was.getAttribute('data-n36ff-made')) was.hidden = true;
      var lv = FF.v[vid];
      if (!on && lv && pdp.price.textContent === money(lv[1])) {
        pdp.price.textContent = money(lv[0]);
        if (pdp.addPrice && pdp.addPrice.textContent) pdp.addPrice.textContent = '— ' + money(lv[0] * qty);
        if (pdp.mobar && /^Add to Basket/.test(pdp.mobar.textContent)) pdp.mobar.textContent = 'Add to Basket — ' + money(lv[0] * qty);
      }
    }
    if (on) {
      document.querySelectorAll('.n36-thickness .n36-thick-opt[data-variant-id]').forEach(function (b) {
        var qp = b.querySelector('.qp');
        var ve = FF.v[b.getAttribute('data-variant-id')];
        if (!qp || !ve || qp.hasAttribute('data-n36ff-qp')) return;
        qp.setAttribute('data-n36ff-qp', qp.innerHTML);
        qp.innerHTML = '<s style="color:#6E6656;font-weight:400;margin-right:.3rem;">' + money(ve[0]) + '</s>' + money(ve[1]);
      });
      paintPdpTags();
    } else {
      unpaintTags();
    }
    // Drop the mutation records our own writes just queued, so only the page's
    // own render() (size or quantity change) triggers the next repaint.
    if (pdpMo) pdpMo.takeRecords();
  }
  function watchPdp() {
    pdp = findPdp();
    if (!pdp || typeof MutationObserver === 'undefined') return;
    pdpMo = new MutationObserver(function () { if (active) pdpRefresh(true); });
    [pdp.price, pdp.addPrice, pdp.mobar].forEach(function (n) {
      if (n) pdpMo.observe(n, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- on / off ---------- */
  function saleNav() {
    document.querySelectorAll(NAV_NEW).forEach(function (link) {
      if (navOriginals.has(link)) return;
      var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT), node, texts = [];
      while ((node = walker.nextNode())) {
        if (!node.nodeValue.trim() || node.parentElement.closest('svg, [aria-hidden="true"], .visually-hidden')) continue;
        texts.push({ node: node, value: node.nodeValue });
      }
      if (!/^What['\u2019]s New$/.test(texts.map(function (entry) { return entry.value; }).join(' ').replace(/\s+/g, ' ').trim())) return;
      var original = { link: link, href: link.getAttribute('href'), marker: link.getAttribute('data-n36ff-nav'), texts: texts };
      navOriginals.set(link, original);
      navUndo.push(original);
      texts.forEach(function (entry, index) {
        // Preserve text-node whitespace, child spans, icons, classes and handlers.
        entry.node.nodeValue = entry.value.replace(/\S(?:[\s\S]*\S)?/, index === 0 ? 'Friends & Family Sale' : '');
      });
      link.setAttribute('href', '/collections/friends-and-family');
      link.setAttribute('data-n36ff-nav', '');
    });
  }
  function restoreNav() {
    navUndo.forEach(function (original) {
      original.texts.forEach(function (entry) { entry.node.nodeValue = entry.value; });
      original.link.setAttribute('href', original.href);
      if (original.marker === null) original.link.removeAttribute('data-n36ff-nav');
      else original.link.setAttribute('data-n36ff-nav', original.marker);
    });
    navUndo = [];
    navOriginals = new WeakMap();
  }
  function turnOn() {
    document.documentElement.classList.add('n36ff-active');
    saleNav();
    if (active) return;
    active = true;
    showBar();
    paintCarousel();
    paintMarked(document);
    showSections(true);
    pdpRefresh(true);
  }
  function turnOff() {
    document.documentElement.classList.remove('n36ff-active');
    restoreNav();
    var lane = document.querySelector('#n36-pairs-with .n36-pw-lane');
    if (lane) lane.dispatchEvent(new Event('scroll'));
    if (!active) return;
    active = false;
    hideBar();
    unpaintAll();
    showSections(false);
  }

  /* ---------- the code on the cart (live mode) ---------- */
  var checkVersion = 0, checkTimer = null, midnightTimer = null, readding = false;
  var readdAttempts = Object.create(null);
  function fullCart(cart) { return !!(cart && Array.isArray(cart.items) && Array.isArray(cart.discount_codes)); }
  function saleCode(cart) {
    var list = (cart && cart.discount_codes) || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code || '').toUpperCase() === FF.code) return list[i];
    }
    return null;
  }
  function hasSaleOnetime(cart) {
    return (cart.items || []).some(function (line) {
      var properties = line.properties || {};
      var bundle = Array.isArray(properties) ? properties.some(function (p) { return p && (p.name === '_rc_bundle' || p.key === '_rc_bundle'); }) : Object.prototype.hasOwnProperty.call(properties, '_rc_bundle');
      return Object.prototype.hasOwnProperty.call(FF.v, String(line.variant_id)) && !line.selling_plan_allocation && !bundle;
    });
  }
  function rejected(cart) {
    var code = saleCode(cart);
    return !!(code && code.applicable === false && hasSaleOnetime(cart));
  }
  /* Everyone who arrives through the link sees the sale (Asher 2026-10-14: "flip it on for anyone
     who arrives in the link"). Shopify decides at checkout who gets the price (past buyers only),
     so a code Shopify marks not applicable no longer turns the display off. */
  function acceptCart(cart) {
    sset('local', LS_SEEN, '1'); sdel('local', LS_OFF); sset('local', LS_CART, String(cart.token || ''));
    turnOn();
    return true;
  }
  /* The sale link (/discount/N36FRIENDS) also saves the code in the browser's discount_code
     cookie. A shopper signed into an account outside the code's audience may not get the code
     on the cart, so the cookie alone also counts as "arrived through the link". */
  function cookieCode() {
    var m = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie || '');
    if (!m) return false;
    try { return decodeURIComponent(m[1]).toUpperCase() === FF.code; } catch (e) { return false; }
  }
  function checkCart(supplied) {
    var version = ++checkVersion;
    if (previewState()) { turnOn(); return Promise.resolve(); }
    if (!inWindow()) { sdel('local', LS_SEEN); sdel('local', LS_OFF); sdel('local', LS_CART); turnOff(); return Promise.resolve(); }
    // Keep the current display while the single restoration POST is unresolved.
    // Its response (or a current read afterward) settles the cart and drawer.
    if (readding) return Promise.resolve();
    var read = fullCart(supplied) ? Promise.resolve(supplied) : fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
    return read.then(function (cart) {
      // A newer cart event, visibility check or midnight transition wins over an old response.
      if (version !== checkVersion || !fullCart(cart)) return;
      if (previewState()) { turnOn(); return; }
      if (!inWindow()) { turnOff(); return; }
      if (saleCode(cart)) { acceptCart(cart); return; }
      if (cookieCode() && sget('local', LS_OFF) !== '1') { acceptCart(cart); return; }
      var codes = cart.discount_codes || [];
      var seen = sget('local', LS_SEEN) === '1', off = sget('local', LS_OFF) === '1';
      var token = String(cart.token || '');
      var sameCart = token === (sget('local', LS_CART) || '');
      if (seen && !off && codes.length === 0 && !sameCart && token && !readding && !readdAttempts[token]) {
        // A new cart after checkout may inherit the code once; concurrent checks
        // cannot post it twice, and the resulting cart event only confirms it.
        readding = true;
        readdAttempts[token] = true;
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: FF.code })
        }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (next) {
            // A failed attempt is settled even if another check superseded its
            // display. An older failure must not trigger another restoration POST.
            if (!fullCart(next) || !saleCode(next)) sset('local', LS_OFF, '1');
            if (version !== checkVersion) {
              // A change happened during the POST. Read current truth rather than
              // repainting or restoring a code from this older response.
              if (saleCode(next) && window.N36Cart && typeof window.N36Cart.refresh === 'function') window.N36Cart.refresh();
              queueCartCheck(null);
              return;
            }
            if (!inWindow()) { turnOff(); return; }
            if (fullCart(next) && saleCode(next)) {
              acceptCart(next);
              if (window.N36Cart && typeof window.N36Cart.refresh === 'function') window.N36Cart.refresh({ cart: next });
            } else {
              sset('local', LS_OFF, '1');
              turnOff();
            }
          }).catch(function () {
            turnOff();
          }).then(function () { readding = false; });
      }
      if (seen && sameCart && codes.length === 0) sset('local', LS_OFF, '1');
      turnOff();
    }).catch(function () {});
  }
  function queueCartCheck(cart) {
    // Invalidate in-flight reads immediately, even during the debounce period.
    var version = ++checkVersion;
    if (checkTimer) clearTimeout(checkTimer);
    checkTimer = setTimeout(function () {
      checkTimer = null;
      // A visibility or midnight check can supersede this event while it waits.
      if (version === checkVersion) checkCart(cart);
    }, 150);
  }
  function centralParts(at) {
    var out = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(at)).forEach(function (p) {
      if (p.type !== 'literal') out[p.type] = Number(p.value);
    });
    return out;
  }
  function scheduleMidnight() {
    if (midnightTimer) clearTimeout(midnightTimer);
    var now = Date.now(), delay = 86400000;
    try {
      var p = centralParts(now);
      var wall = Date.UTC(p.year, p.month - 1, p.day + 1);
      var next = wall + 21600000;
      for (var i = 0; i < 3; i++) {
        var q = centralParts(next);
        var offset = Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second) - Math.floor(next / 1000) * 1000;
        next = wall - offset;
      }
      delay = Math.min(86400000, Math.max(1000, next - now + 25));
    } catch (e) {}
    midnightTimer = setTimeout(function () { checkCart(); scheduleMidnight(); }, delay);
  }

  // Cards that arrive later (quick-add dialogs, carousels, lanes).
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (muts) {
      if (!active) return;
      saleNav();
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-n36ff-c], input[data-n36-qa-sel]') || n.querySelector('[data-n36ff-c], input[data-n36-qa-sel]'))) { paintCarousel(); paintMarked(n.parentNode || n); }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    watchPdp();
    if (!document.getElementById('n36ff-display-style')) {
      var style = document.createElement('style');
      style.id = 'n36ff-display-style';
      style.textContent = 'html.n36ff-active #n36-pairs-with{display:none!important;}html.n36ff-active a[data-n36ff-nav],html.n36ff-active a[data-n36ff-nav]>span{color:#7A332B!important;}' +
        /* Sale tags: same build as the New badge (.n36-card-new / .n36-pdp-new), brand oxblood on every product */
        '.n36ff-tag{background:#7A332B;color:#fff;font-family:\'F37 Lineca\',\'F37Lineca-Bold\',Helvetica,Arial,sans-serif;font-weight:700;text-transform:uppercase;line-height:1;border-radius:2px;pointer-events:none;}' +
        '.n36ff-tag--card{position:absolute;top:12px;left:12px;z-index:3;font-size:11px;letter-spacing:.12em;padding:6px 9px;}' +
        '.n36ff-tag--card.n36ff-tag--below{top:42px;}' +
        '.n36ff-tag--pdp{position:absolute;top:14px;left:14px;z-index:3;font-size:12px;letter-spacing:.12em;padding:7px 11px;}' +
        '.n36ff-tag--pdp.n36ff-tag--below{top:50px;}' +
        '.n36ff-tag--inline{display:inline-block;vertical-align:middle;margin-left:8px;font-size:9px;letter-spacing:.1em;padding:4px 6px;position:relative;top:-1px;}';
      document.head.appendChild(style);
    }
    document.addEventListener('n36cart:updated', function (event) { queueCartCheck(event.detail && event.detail.cart); });
    // The cart's remove-code x: the shopper took the code off, so the link cookie goes too.
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest || !t.closest('.n36-remove-discount')) return;
      document.cookie = 'discount_code=; Max-Age=0; path=/';
      sset('local', LS_OFF, '1');
    }, true);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { checkCart(); scheduleMidnight(); }
    });
    scheduleMidnight();
    if (previewState()) { turnOn(); return; }
    // A shopper who already has the code: paint right away so prices don't
    // flash at list first, then confirm against the cart.
    if (inWindow() && sget('local', LS_SEEN) === '1' && sget('local', LS_OFF) !== '1') turnOn();
    checkCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.N36FF = { on: turnOn, off: turnOff, config: FF };
})();
